import { render, staticRenderFns } from "./NascidoSV.vue?vue&type=template&id=36fcc8e5&"
import script from "./NascidoSV.vue?vue&type=script&lang=js&"
export * from "./NascidoSV.vue?vue&type=script&lang=js&"
import style0 from "./NascidoSV.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports